/**
 * CORE-740 (QA fail) — «карточка завершённой сессии показывает ОНЛАЙН и
 * Присоединиться».
 *
 * The shared event card (`PublicMasterEventCard`) had no notion of a finished
 * event: the cover badge always announced the FORMAT («ОНЛАЙН» / «ОФЛАЙН»,
 * green dot) and the primary CTA always read «Присоединиться». A session that
 * had already ended therefore looked joinable, and the tap landed on «Сессия
 * завершена» — measured on dev, post 496 / session 1490, whose payload said
 * `eventState: "past"` all along. The backend was right; the card ignored it.
 *
 * PURE by design (no React / RN imports) so the rules unit-test in the node
 * env, mirroring `liveSessionDisplay.ts`.
 */

/**
 * A «…_recorded» kind is how every surface spells «это уже прошло»:
 * CommunityFeed derives it from the BE `eventState === 'past'`, the master's
 * «События» tab from its own upcoming / past split. Keying off the kind means
 * the card needs no extra prop and both surfaces stay in step.
 */
export function isPastEventKind(kind: string): boolean {
  return kind.endsWith('_recorded');
}

export type EventCardStatusTone = 'upcoming' | 'past';

export interface EventCardStatus {
  label: string;
  tone: EventCardStatusTone;
}

/**
 * Cover-overlay badge. While the event is ahead (or running) it names the
 * format, as it always did; once it is over it names the actual state — the
 * ticket's «карточка отображает актуальный статус сессии».
 */
export function eventCardStatus(kind: string): EventCardStatus {
  const offline = kind.startsWith('offline_');
  if (isPastEventKind(kind)) {
    // «Событие» is neuter, «сессия» feminine — the badge agrees with whatever
    // it sits on.
    return { label: offline ? 'ЗАВЕРШЕНО' : 'ЗАВЕРШЕНА', tone: 'past' };
  }
  if (offline) return { label: 'ОФЛАЙН', tone: 'upcoming' };
  if (kind === 'practice_uploaded') return { label: 'ПРАКТИКА', tone: 'upcoming' };
  return { label: 'ОНЛАЙН', tone: 'upcoming' };
}
